import { Form, Input, InputNumber, Select } from "antd";
import { useEffect, useState } from "react";
import { api } from "../common/api";
import { filterOption, requiredField } from "../common/common";

export default function MansionFields({ editing = false }) {
  const [courses, setCourses] = useState([]);
  const [dpis, setDpis] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.courseType.list({ pageSize: 9999 }), api.dpi.list({ pageSize: 9999 })])
      .then(([courses, dpis]) => {
        setCourses(courses.data.map((course) => ({ label: course.title, value: course.id })));
        setDpis(dpis.data.map((dpi) => ({ label: dpi.name, value: dpi.id })));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Form.Item
        name="name"
        label="Nome"
        rules={[requiredField, { whitespace: true, message: "Campo obbligatorio" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="requiredCourseTypes" label="Corsi richiesti" initialValue={[]}>
        <Select
          mode="multiple"
          allowClear
          showSearch
          filterOption={filterOption}
          options={courses}
          loading={loading}
        />
      </Form.Item>
      <Form.Item name="requiredDpis" label="DPI richiesti" initialValue={[]}>
        <Select
          mode="multiple"
          allowClear
          showSearch
          filterOption={filterOption}
          options={dpis}
          loading={loading}
        />
      </Form.Item>
    </>
  );
}
